import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { SnapshotHistorySetting } from 'types';

export const getSnapshotHistorySettings = async (
  snapshotId: number
): Promise<SnapshotHistorySetting | undefined> => {
  if (snapshotId < 1) return;
  const { data }: { data: SnapshotHistorySetting[] } = await axios.get(
    `/api/snapshots/${snapshotId}/history/settings`
  );
  return data[0] as SnapshotHistorySetting;
};

type QueryFnType = typeof getSnapshotHistorySettings;

type UseSnapshotHistorySettingsOptions = {
  snapshotId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useSnapshotHistorySettings = ({
  snapshotId,
  config,
}: UseSnapshotHistorySettingsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['snapshot', 'historySettings', snapshotId],
    queryFn: () => getSnapshotHistorySettings(snapshotId),
  });
};
